window.reboltCartCallBack = function () {
  const refreshEvent = new CustomEvent("cart:refresh", {
    bubbles: true,
    detail: {
      open: true,
    },
  });
  document.dispatchEvent(refreshEvent);

  // Wait for the cart drawer content to update and then re-attach the close listener
  const cartDrawer = document.getElementById("CartDrawer");
  if (cartDrawer) {
    // We listen for the transition end or check after a short delay
    // Since the refresh is async, we can try to hook into the component's behavior or just re-query
    setTimeout(() => {
      const closeBtn = cartDrawer.querySelector(".drawer__close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
          e.preventDefault();
          cartDrawer.hide();
        });
      }
    }, 500);
  }
};

const reboltObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      const buildBoxAccordion = document.querySelector(
        ".RB_BuildBoxInfo .RB_Accordion_Content",
      );
      const buildBoxAccordionHead = document.querySelector(
        ".RB_BuildBoxInfo .RB_Accordion_Head",
      );

      // --- Two-phase progress indicator ---
      const TIER_1_ITEMS = 3;
      const TIER_1_DISCOUNT = 0.15;
      const TIER_2_ITEMS = 4;
      const TIER_2_DISCOUNT = 0.2;
      const MAX_ITEMS = 8;

      const progressHolder = document.createElement("div");
      progressHolder.classList.add("RB_ProgressHolder");

      let infoBarStatus = null;

      // Phase 1: 4-stop stepper (visible when count < MIN_ITEMS)
      const stepper = document.createElement("div");
      stepper.classList.add("RB_Stepper");

      const stepperTrack = document.createElement("div");
      stepperTrack.classList.add("RB_StepperTrack");
      const stepperFill = document.createElement("div");
      stepperFill.classList.add("RB_StepperFill");
      stepperFill.style.width = "0%";
      stepperTrack.appendChild(stepperFill);
      stepper.appendChild(stepperTrack);

      // 3 stops (one per item needed for first tier) — all visible from the start
      for (let i = 0; i < TIER_1_ITEMS; i++) {
        const stop = document.createElement("div");
        stop.classList.add("RB_StepperStop");
        stop.dataset.step = i;
        if (i === 0) {
          stop.classList.add("RB_is-current");
          stop.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
        } else {
          stop.classList.add("RB_is-empty");
        }
        stepper.appendChild(stop);
      }

      const stepperLabel = document.createElement("div");
      stepperLabel.classList.add("RB_StepperLabel");
      stepperLabel.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Add 3 items to unlock 15% off';

      // Phase 2: unlocked badge + optional capacity bar (visible when count >= MIN_ITEMS)
      const unlockedWrap = document.createElement("div");
      unlockedWrap.classList.add("RB_UnlockedWrap");

      const unlockedBadge = document.createElement("div");
      unlockedBadge.classList.add("RB_UnlockedBadge");
      unlockedBadge.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> 20% off unlocked!';

      const capacityTrack = document.createElement("div");
      capacityTrack.classList.add("RB_CapacityTrack");
      const capacityFill = document.createElement("div");
      capacityFill.classList.add("RB_CapacityFill");
      capacityTrack.appendChild(capacityFill);

      const capacityRow = document.createElement("div");
      capacityRow.classList.add("RB_CapacityRow");
      const capacityCount = document.createElement("div");
      capacityCount.classList.add("RB_CapacityCount");

      capacityRow.appendChild(capacityTrack);
      capacityRow.appendChild(capacityCount);

      const remainderEl = document.createElement("div");
      remainderEl.classList.add("RB_UnlockedRemainder");

      unlockedWrap.appendChild(capacityRow);
      unlockedWrap.appendChild(unlockedBadge);
      unlockedWrap.appendChild(remainderEl);

      const progressSlider = document.createElement("div");
      progressSlider.classList.add("RB_ProgressSlider");

      const stepperStage = document.createElement("div");
      stepperStage.classList.add(
        "RB_ProgressStage",
        "RB_ProgressStage--stepper",
      );
      stepperStage.appendChild(stepper);
      stepperStage.appendChild(stepperLabel);

      const unlockedStage = document.createElement("div");
      unlockedStage.classList.add(
        "RB_ProgressStage",
        "RB_ProgressStage--unlocked",
      );
      unlockedStage.appendChild(unlockedWrap);

      progressSlider.appendChild(stepperStage);
      progressSlider.appendChild(unlockedStage);
      progressHolder.appendChild(progressSlider);

      const infoBarTitle = document.querySelector(".RB_BuildBoxInfoBar h5");

      if (infoBarTitle) {
        const infoBar = infoBarTitle.parentElement;
        let headerWrap = infoBar.querySelector(".RB_BuildBoxInfoBarHeader");
        if (!headerWrap) {
          headerWrap = document.createElement("div");
          headerWrap.className = "RB_BuildBoxInfoBarHeader";
          infoBar.insertBefore(headerWrap, infoBarTitle);
          headerWrap.appendChild(infoBarTitle);

          infoBarStatus = document.createElement("div");
          infoBarStatus.className = "RB_BuildBoxInfoBarStatus";
          headerWrap.appendChild(infoBarStatus);
        } else {
          infoBarStatus = headerWrap.querySelector(".RB_BuildBoxInfoBarStatus");
          if (!infoBarStatus) {
            infoBarStatus = document.createElement("div");
            infoBarStatus.className = "RB_BuildBoxInfoBarStatus";
            headerWrap.appendChild(infoBarStatus);
          }
        }

        headerWrap.insertAdjacentElement("afterend", progressHolder);
      } else if (buildBoxAccordionHead) {
        buildBoxAccordionHead.appendChild(progressHolder);
      }

      if (buildBoxAccordion) {
        console.log("Found build box accordion:", buildBoxAccordion);
        reboltObserver.disconnect();

        const updateInfoBarHeight = () => {
          const infoBar = document.querySelector(".RB_BuildBoxInfoBar");
          if (infoBar) {
            const height = infoBar.offsetHeight;
            document.body.style.setProperty(
              "--box-builder-info-height",
              `${height}px`,
            );
          }
        };
        updateInfoBarHeight();

        const boxTitle = document.querySelector(".RB_BuildBoxInfoBar h5");
        if (boxTitle) {
          boxTitle.innerHTML = "Your ritual";
        }
        const boxSubtitle = document.querySelector(".RB_AH_Title");
        if (boxSubtitle) {
          boxSubtitle.innerHTML = "Add an item to get started.";
        }

        document.querySelectorAll("a.dd").forEach((link) => {
          if (!link.querySelector(".quick-look-icon")) {
            const span = document.createElement("span");
            span.className = "quick-look-icon";
            span.innerHTML =
              '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>';
            link.appendChild(span);
          }
        });

        // Fetch BYOB products JSON and apply size tags to product cards
        let productsCache = null;
        let productsPromise = null;
        let productMetaApplied = false;
        const ENABLE_PRODUCT_CACHE = false;

        const updateAddToCartButton = (count) => {
          const labelEl = document.querySelector(
            ".RB_BuildBox_AddToCart .RB_Button_text",
          );
          if (!labelEl) return;
          const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

          const remaining = Math.max(
            TIER_1_ITEMS - (isNaN(count) ? 0 : count),
            0,
          );
          let text;

          if (remaining <= 0) {
            text = "Add to cart";
          } else if (remaining === 3) {
            text = isDesktop ? "Start building" : "Start building";
          } else if (remaining === 2) {
            text = isDesktop ? "2 more to unlock" : "2 more to unlock";
          } else {
            text = isDesktop ? "1 more to unlock" : "1 more to unlock";
          }

          labelEl.textContent = text;
        };

        const initialCountEl = document.querySelector(
          ".RB_BuildBoxInfo .RB_AH_Count",
        );
        const initialCount = initialCountEl
          ? parseInt(initialCountEl.innerHTML.split(" ")[0]) || 0
          : 0;
        updateAddToCartButton(initialCount);
        progressHolder.dataset.stage =
          initialCount >= TIER_2_ITEMS
            ? "2"
            : initialCount >= TIER_1_ITEMS
              ? "1"
              : "0";

        /* Reordering disabled to avoid observer feedback loops */

        const applyProductSizes = (products) => {
          if (!products || !Array.isArray(products)) {
            console.warn(
              "[BYOB] applyProductSizes: invalid products payload",
              products,
            );
            return false;
          }
          const cards = document.querySelectorAll(".RB_Product_Card[data-id]");
          const productCount = products.length;
          const cardCount = cards.length;
          console.debug("[BYOB] applyProductSizes: begin", {
            productCount,
            cardCount,
          });
          if (!cardCount) return false;
          const byId = new Map();
          products.forEach((p) => byId.set(String(p.id), p));
          cards.forEach((card) => {
            const id = card.getAttribute("data-id");
            const product = byId.get(String(id));
            if (!product || !Array.isArray(product.tags)) return;

            // Extract tags
            const sizeTag = product.tags.find(
              (t) =>
                typeof t === "string" && t.toLowerCase().startsWith("size_"),
            );

            const priceEl = card.querySelector(".RB_PC_Price");

            // Handle size tag (attribute + visible label)
            if (sizeTag && priceEl) {
              const display = sizeTag.replace(/^size_/i, "").replace(/_/g, " ");
              card.setAttribute(
                "data-product-size",
                sizeTag.replace(/^size_/i, ""),
              );

              let sizeEl = priceEl.querySelector(".product-size");
              if (!sizeEl) {
                sizeEl = document.createElement("span");
                sizeEl.className = "product-size";
              }
              sizeEl.textContent = display;

              let bulletEl = priceEl.querySelector(".product-size-sep");
              if (!bulletEl) {
                bulletEl = document.createElement("span");
                bulletEl.className = "product-size-sep";
                bulletEl.textContent = "•";
              }

              // Ensure size and bullet are at the beginning, size first then bullet
              if (priceEl.firstChild !== sizeEl) {
                priceEl.insertBefore(sizeEl, priceEl.firstChild);
              }
              if (sizeEl.nextSibling !== bulletEl) {
                priceEl.insertBefore(bulletEl, sizeEl.nextSibling);
              }
            }

            const mediaEl = card.querySelector(".RB_PC_Media");
            if (mediaEl && Array.isArray(product.tags)) {
              const categoryTags = product.tags.filter(
                (t) =>
                  typeof t === "string" &&
                  t.toLowerCase().startsWith("category_"),
              );
              if (categoryTags.length) {
                let wrapper =
                  mediaEl.nextElementSibling &&
                  mediaEl.nextElementSibling.classList &&
                  mediaEl.nextElementSibling.classList.contains(
                    "RB_ProductCategories",
                  )
                    ? mediaEl.nextElementSibling
                    : mediaEl.parentElement.querySelector(
                        ".RB_ProductCategories",
                      );
                if (!wrapper) {
                  wrapper = document.createElement("div");
                  wrapper.className = "RB_ProductCategories";
                  mediaEl.insertAdjacentElement("afterend", wrapper);
                } else if (mediaEl.nextElementSibling !== wrapper) {
                  mediaEl.parentElement.insertBefore(
                    wrapper,
                    mediaEl.nextElementSibling,
                  );
                }

                const seen = new Set();
                categoryTags.forEach((tag) => {
                  const raw = tag.replace(/^category_/i, "");
                  const displayCat = raw.replace(/_/g, " ").trim();
                  const classSuffix = raw
                    .toLowerCase()
                    .trim()
                    .replace(/[ +]+/g, "-")
                    .replace(/[^a-z0-9-]/g, "-")
                    .replace(/-+/g, "-");
                  const className =
                    "RB_ProductCategory category_" + classSuffix;
                  if (seen.has(className)) return;
                  seen.add(className);

                  let span = wrapper.querySelector("." + className);
                  if (!span) {
                    span = document.createElement("span");
                    span.className = className;
                    wrapper.appendChild(span);
                  }
                  span.textContent = displayCat;
                });

                Array.from(
                  wrapper.querySelectorAll('span[class^="category_"]'),
                ).forEach((el) => {
                  if (!seen.has(el.className)) el.remove();
                });
              }
            }
          });
          console.debug("[BYOB] applyProductSizes: done");
          return true;
        };

        const ensureProducts = () => {
          const fetchProducts = () => {
            console.debug(
              "[BYOB] ensureProducts: fetching /collections/build-your-own-box/products.json",
            );
            const cachebuster = Date.now();
            return fetch(
              `/collections/build-your-own-box/products.json?cb=${cachebuster}`,
            )
              .then((r) => {
                console.debug("[BYOB] ensureProducts: response", {
                  ok: r.ok,
                  status: r.status,
                });
                return r.json();
              })
              .then((json) => {
                const list = (json && json.products) || [];
                console.debug("[BYOB] ensureProducts: parsed products", {
                  count: list.length,
                });
                return list;
              })
              .catch((e) => {
                console.error("BYOB products fetch failed", e);
                return [];
              });
          };

          if (!ENABLE_PRODUCT_CACHE) {
            console.debug("[BYOB] ensureProducts: cache disabled");
            return fetchProducts();
          }

          if (productsCache) {
            console.debug("[BYOB] ensureProducts: cache hit", {
              count: productsCache.length,
            });
            return Promise.resolve(productsCache);
          }
          if (productsPromise) {
            console.debug("[BYOB] ensureProducts: promise in-flight");
            return productsPromise;
          }

          productsPromise = fetchProducts().then((list) => {
            productsCache = list;
            return productsCache;
          });

          return productsPromise;
        };

        // Initial one-time population with cautious retry if cards are not yet in DOM
        let applyAttempts = 0;
        const MAX_APPLY_ATTEMPTS = 3;
        const RETRY_DELAY_MS = 200;
        if (!productMetaApplied) {
          const runApply = () => {
            ensureProducts().then((products) => {
              const applied = applyProductSizes(products);
              if (applied) {
                productMetaApplied = true;
                console.debug("[BYOB] product metadata applied");
              } else if (applyAttempts < MAX_APPLY_ATTEMPTS) {
                applyAttempts += 1;
                console.debug(
                  "[BYOB] applyProductSizes: no cards yet, retrying",
                  { attempt: applyAttempts },
                );
                setTimeout(runApply, RETRY_DELAY_MS * applyAttempts);
              } else {
                console.warn("[BYOB] applyProductSizes: gave up after retries");
              }
            });
          };
          runApply();
        }

        // Watch for changes on the found element
        const buildBoxObserver = new MutationObserver((changes) => {
          const boxCount = document.querySelector(
            ".RB_BuildBoxInfo .RB_AH_Count",
          );
          if (boxCount) {
            const boxCountInt = parseInt(boxCount.innerHTML.split(" ")[0]);
            const isTier1 = boxCountInt >= TIER_1_ITEMS;
            const isTier2 = boxCountInt >= TIER_2_ITEMS;
            const activeDiscount = isTier2
              ? TIER_2_DISCOUNT
              : isTier1
                ? TIER_1_DISCOUNT
                : 0;

            updateAddToCartButton(boxCountInt);
            progressHolder.dataset.stage = isTier2 ? "2" : isTier1 ? "1" : "0";

            // --- Phase 1: stepper (0 to TIER_1_ITEMS-1) ---
            if (!isTier1) {
              // Fill width: each completed stop is a fraction of the track
              const fillPercent =
                boxCountInt === 0
                  ? 0
                  : (boxCountInt / (TIER_1_ITEMS - 1)) * 100;
              stepperFill.style.width = Math.min(fillPercent, 100) + "%";

              // Update stops: filled, current (with +), or empty
              const stops = stepper.querySelectorAll(".RB_StepperStop");
              stops.forEach((stop) => {
                const step = parseInt(stop.dataset.step);
                stop.classList.remove(
                  "RB_is-filled",
                  "RB_is-current",
                  "RB_is-empty",
                );
                stop.innerHTML = "";
                if (step < boxCountInt) {
                  stop.classList.add("RB_is-filled");
                  stop.innerHTML =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
                } else if (step === boxCountInt) {
                  stop.classList.add("RB_is-current");
                  stop.innerHTML =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
                } else {
                  stop.classList.add("RB_is-empty");
                }
              });

              // Label
              const remaining = TIER_1_ITEMS - boxCountInt;
              if (boxCountInt === 0) {
                stepperLabel.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Add 3 items to unlock 15% off';
                boxSubtitle.innerHTML = "Add an item to get started.";
              } else {
                stepperLabel.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Add ${remaining} more to unlock 15% off`;
                boxSubtitle.innerHTML = "";
              }

              // --- Phase 2: unlocked (TIER_1_ITEMS to MAX_ITEMS) ---
            } else {
              // Update badge text depending on tier
              if (isTier2) {
                unlockedBadge.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> 20% off unlocked!';
              } else {
                unlockedBadge.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> 15% off &ndash; add 1 more for 20%';
              }

              const capacityPercent = (boxCountInt / MAX_ITEMS) * 100;
              capacityFill.style.width = Math.min(capacityPercent, 100) + "%";

              capacityCount.textContent = `${boxCountInt}/${MAX_ITEMS}`;

              const remainingCapacity = MAX_ITEMS - boxCountInt;
              if (remainingCapacity <= 0) {
                remainderEl.textContent = "Box full!";
                capacityTrack.classList.add("RB_is-full");
              } else if (remainingCapacity === 5) {
                remainderEl.textContent = ``;
                capacityTrack.classList.remove("RB_is-full");
              } else {
                remainderEl.textContent = `Add up to ${remainingCapacity} more`;
                capacityTrack.classList.remove("RB_is-full");
              }

              boxSubtitle.innerHTML = "";
            }

            // --- Price display ---
            const priceEl = document.querySelector(
              ".RB_BuildBoxInfoBar .RB_AH_Price, .RB_BuildBoxInfo .RB_BB_Total",
            );
            if (priceEl) {
              const rawPrice = priceEl.textContent.replace(/[^0-9.]/g, "");
              const subtotal = parseFloat(rawPrice);
              if (!isNaN(subtotal) && subtotal > 0) {
                let priceDisplay =
                  priceEl.parentElement.querySelector(".RB_PriceDisplay");
                if (!priceDisplay) {
                  priceDisplay = document.createElement("div");
                  priceDisplay.classList.add("RB_PriceDisplay");
                  priceEl.insertAdjacentElement("afterend", priceDisplay);
                  priceEl.style.display = "none";
                }
                if (activeDiscount > 0) {
                  const discounted = (subtotal * (1 - activeDiscount)).toFixed(
                    2,
                  );
                  priceDisplay.innerHTML = `<span class="RB_PriceDiscounted">&pound;${discounted}</span><span class="RB_PriceOriginal">&pound;${subtotal.toFixed(2)}</span>`;
                } else {
                  priceDisplay.innerHTML = `<span class="RB_PriceSubtotal">&pound;${subtotal.toFixed(2)}</span>`;
                }
              }
            }

            updateInfoBarHeight();

            const list = document.querySelector(
              ".RB_BuildBoxInfo .RB_Accordion_Content ul",
            );
            if (list) {
              list.scrollTop = 0;
            }
          }
        });

        buildBoxObserver.observe(buildBoxAccordion, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
        });

        break; // Stop processing mutations once found
      }
    }
  }
});

reboltObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("click", (e) => {
  const link = e.target.closest(".RB_PC_Media a, .RB_PC_Title a");
  if (link && link.href && link.href.includes("/products/")) {
    const quickViewModal = document.querySelector("quick-view-modal");
    if (quickViewModal) {
      e.preventDefault();
      quickViewModal.dataset.productUrl = link.href;
      quickViewModal.show(link);
    }
  }
});
